<template>
  <div class="inspection-item-tab">
    <!-- 搜索栏 -->
    <div class="search-bar">
      <el-select
        v-model="searchForm.vehicleId"
        placeholder="请选择车辆"
        style="width: 200px; margin-right: 10px"
        clearable
        filterable
      >
        <el-option label="全局" value="" />
        <el-option
          v-for="vehicle in vehicleList"
          :key="vehicle.vehicleId"
          :label="getVehicleDisplayName(vehicle)"
          :value="vehicle.vehicleId"
        />
      </el-select>
      <el-input
        v-model="searchForm.reportId"
        placeholder="请输入报告ID"
        style="width: 200px; margin-right: 10px"
        clearable
      />
      <el-select
        v-model="searchForm.status"
        placeholder="请选择状态"
        style="width: 150px; margin-right: 10px"
        clearable
      >
        <el-option label="正常" value="normal" />
        <el-option label="瑕疵" value="defect" />
        <el-option label="不可检测" value="uninspectable" />
      </el-select>
      <el-button type="primary" @click="handleSearch">搜索</el-button>
      <el-button @click="handleReset">重置</el-button>
      <el-button type="success" @click="handleAdd">新增</el-button>
    </div>
    
    <!-- 数据表格 -->
    <el-table :data="tableData" border style="width: 100%; margin-top: 20px">
      <el-table-column prop="itemId" label="项目ID" width="150" />
      <el-table-column prop="vehicleId" label="车辆ID" width="150" />
      <el-table-column prop="reportId" label="报告ID" width="150" />
      <el-table-column prop="name" label="项目名称" width="200" />
      <el-table-column prop="status" label="状态" width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 'normal'" type="success">正常</el-tag>
          <el-tag v-else-if="scope.row.status === 'defect'" type="danger">瑕疵</el-tag>
          <el-tag v-else-if="scope.row.status === 'uninspectable'" type="warning">不可检测</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="checked" label="已检测" width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.checked === 1" type="success">是</el-tag>
          <el-tag v-else type="info">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" show-overflow-tooltip />
      <el-table-column prop="sortOrder" label="排序" width="80" />
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.current"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagination.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
      style="margin-top: 20px; text-align: right"
    />
    
    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-form-item label="车辆" prop="vehicleId">
          <el-select v-model="form.vehicleId" placeholder="请选择车辆" style="width: 100%" @change="handleVehicleChange">
            <el-option
              v-for="vehicle in vehicleList"
              :key="vehicle.vehicleId"
              :label="getVehicleDisplayName(vehicle)"
              :value="vehicle.vehicleId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="报告ID" prop="reportId">
          <el-select v-model="form.reportId" placeholder="请选择报告" style="width: 100%" filterable>
            <el-option
              v-for="report in reportList"
              :key="report.reportId"
              :label="`${report.title} (${report.reportId})`"
              :value="report.reportId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="项目名称" prop="name">
          <el-select v-model="form.name" placeholder="请选择项目名称" style="width: 100%" filterable>
            <el-option
              v-for="template in templateList"
              :key="template.templateId"
              :label="template.name"
              :value="template.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="form.status" placeholder="请选择状态" style="width: 100%">
            <el-option label="正常" value="normal" />
            <el-option label="瑕疵" value="defect" />
            <el-option label="不可检测" value="uninspectable" />
          </el-select>
        </el-form-item>
        <el-form-item label="已检测" prop="checked">
          <el-switch
            v-model="form.checked"
            :active-value="1"
            :inactive-value="0"
            active-text="是"
            inactive-text="否"
          />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="form.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入备注"
          />
        </el-form-item>
        <el-form-item label="排序" prop="sortOrder">
          <el-input-number v-model="form.sortOrder" :min="0" style="width: 100%" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getInspectionItemList, addInspectionItem, updateInspectionItem, deleteInspectionItem, getReportOptions, getTemplateOptions } from '@/api/inspectionItem'
import request from '@/utils/request'

export default {
  name: 'InspectionItemTab',
  data() {
    return {
      searchForm: {
        vehicleId: '',
        reportId: '',
        status: ''
      },
      vehicleList: [],
      reportList: [],
      templateList: [],
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '新增检测项目',
      form: {
        vehicleId: '',
        reportId: '',
        name: '',
        status: 'normal',
        checked: 0,
        remark: '',
        sortOrder: 0
      },
      rules: {
        vehicleId: [
          { required: true, message: '请选择车辆', trigger: 'change' }
        ],
        reportId: [
          { required: true, message: '请输入报告ID', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入项目名称', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ],
        sortOrder: [
          { required: true, message: '请输入排序', trigger: 'blur' }
        ]
      },
      isEdit: false,
      editId: null
    }
  },
  mounted() {
    this.loadVehicleList()
    this.loadTemplateList()
    this.loadData()
  },

  methods: {
    // 加载车辆列表
    async loadVehicleList() {
      try {
        const response = await request.get('/api/admin/guarantee/vehicle/options')
        if (response.code === '200') {
          this.vehicleList = response.data || []
        } else {
          console.error('加载车辆列表失败:', response.msg)
        }
      } catch (error) {
        console.error('加载车辆列表失败:', error)
      }
    },
    
    // 获取车辆显示名称
    getVehicleDisplayName(vehicle) {
      return `${vehicle.brand} ${vehicle.model} (${vehicle.vehicleId})`
    },
    
    // 加载模板列表
    async loadTemplateList() {
      try {
        const response = await getTemplateOptions()
        if (response.code === '200') {
          this.templateList = response.data || []
        } else {
          console.warn('加载模板列表失败:', response.msg)
          this.templateList = []
        }
      } catch (error) {
        console.warn('加载模板列表失败:', error)
        this.templateList = []
      }
    },
    
    // 加载报告列表
    async loadReportList(vehicleId) {
      try {
        const response = await getReportOptions(vehicleId)
        if (response.code === '200') {
          this.reportList = response.data || []
        } else {
          console.warn('加载报告列表失败:', response.msg)
          this.reportList = []
        }
      } catch (error) {
        console.warn('加载报告列表失败:', error)
        this.reportList = []
      }
    },
    
    // 加载数据
    async loadData() {
      try {
        const params = {
          current: this.pagination.current,
          size: this.pagination.size,
          vehicleId: this.searchForm.vehicleId,
          reportId: this.searchForm.reportId,
          status: this.searchForm.status
        }
        const response = await getInspectionItemList(params)
        if (response.code === '200') {
          this.tableData = response.data.records
          this.pagination.total = response.data.total
        } else {
          this.$message.error(response.msg || '获取数据失败')
        }
      } catch (error) {
        console.error('加载数据失败:', error)
        this.$message.error('网络错误，请重试')
      }
    },
    
    // 搜索
    handleSearch() {
      this.pagination.current = 1
      this.loadData()
    },
    
    // 重置
    handleReset() {
      this.searchForm.vehicleId = ''
      this.searchForm.reportId = ''
      this.searchForm.status = ''
      this.pagination.current = 1
      this.loadData()
    },
    
    // 车辆选择变化
    handleVehicleChange(vehicleId) {
      this.form.reportId = ''
      this.loadReportList(vehicleId)
    },
    
    // 新增
    handleAdd() {
      this.isEdit = false
      this.dialogTitle = '新增检测项目'
      this.form = {
        vehicleId: '',
        reportId: '',
        name: '',
        status: 'normal',
        checked: 0,
        remark: '',
        sortOrder: 0
      }
      this.reportList = []
      this.dialogVisible = true
    },
    
    // 编辑
    handleEdit(row) {
      this.isEdit = true
      this.editId = row.id
      this.dialogTitle = '编辑检测项目'
      this.form = { ...row }
      // 加载对应车辆的报告列表
      if (row.vehicleId) {
        this.loadReportList(row.vehicleId)
      }
      this.dialogVisible = true
    },
    
    // 删除
    handleDelete(row) {
      this.$confirm('确认删除该检测项目吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await deleteInspectionItem(row.id)
          if (response.code === '200') {
            this.$message.success('删除成功')
            this.loadData()
          } else {
            this.$message.error(response.msg || '删除失败')
          }
        } catch (error) {
          console.error('删除失败:', error)
          this.$message.error('网络错误，请重试')
        }
      })
    },
    
    // 提交表单
    handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            let response
            if (this.isEdit) {
              response = await updateInspectionItem(this.form)
            } else {
              response = await addInspectionItem(this.form)
            }
            
            if (response.code === '200') {
              this.$message.success(this.isEdit ? '更新成功' : '添加成功')
              this.dialogVisible = false
              this.loadData()
            } else {
              this.$message.error(response.msg || (this.isEdit ? '更新失败' : '添加失败'))
            }
          } catch (error) {
            console.error('提交失败:', error)
            this.$message.error('网络错误，请重试')
          }
        }
      })
    },
    

    
    // 分页大小改变
    handleSizeChange(size) {
      this.pagination.size = size
      this.loadData()
    },
    
    // 当前页改变
    handleCurrentChange(current) {
      this.pagination.current = current
      this.loadData()
    }
  }
}
</script>

<style scoped>
.inspection-item-tab {
  padding: 20px;
}

.search-bar {
  margin-bottom: 20px;
}
</style> 